<div class="search-suggestions-overlay no-scroll" [class.home-page]="onHomePage" *ngIf="showOverlay" [@fadeInOut]></div>